import React, { useEffect, useState } from "react";

import "./AssetCircle.scss";

interface AssetCircleProps {
  radius: number;
  value: string;
  fixedIncome: number;
  assetName: string[];
  percentageInvested: number;
  investment: boolean;
}
interface HoverData {
  assetName: any;
  fixedIncome: string | number;
  percentageInvested: string | number;
}

export default function AssetCircle({
  radius,
  value,
  fixedIncome,
  assetName,
  percentageInvested,
  investment,
}: AssetCircleProps) {
  const [onHoverData, setOnHoverData] = useState<HoverData>({
    assetName: "",
    fixedIncome: 0,
    percentageInvested: 0,
  });
  let backgroundStyle: React.CSSProperties = {};

  useEffect(() => {
    setOnHoverData({
      assetName: investment ? assetName : "",
      fixedIncome: `${Math.round(fixedIncome * 100) / 100}%`,
      percentageInvested: `${Math.round(percentageInvested * 100) / 100}%`,
    });
  }, [fixedIncome, assetName, percentageInvested]);

  //---------------------------------------------------------------------------------//
  //-------------css for the fixed income and bubble acc to grid-----------------------//
  //---------------------------------------------------------------------------------//

  if (
    value === "SHORTTAXDEF" ||
    value === "INTERNTAXDEF" ||
    value === "LONGTAXDEF"
  ) {
    backgroundStyle = {
      background: `radial-gradient(
        ellipse at left,
        #FFD6C7 0%,
        #FFBFB0 25%,
        #FF8C7C 50%,
        #FF7B6A 75%,
        #FF6B58 100%
      )`,
      backgroundImage: `linear-gradient(
        to top, #a8a8a8 ${fixedIncome}%  ,
        #FFD6C7 0%,
        #FFBFB0 25%,
        #FF8C7C 50%,
        #FF7B6A 75%,
        #FF6B58 100% ${100 - fixedIncome}%)`,
    };
  } else if (
    value === "SHORTTAXABLE" ||
    value === "INTERNTAXABLE" ||
    value === "LONGTAXABLE"
  ) {
    backgroundStyle = {
      background: `radial-gradient(
        ellipse at left,
        #f0f7f9 0%,
        #d8ebf1 25%,
        #9cb9ca 50%,
        #7ea1b2 75%,
        #627f90 100%
      )`,
      backgroundImage: `linear-gradient(
        to top, #B8B8B8  ${fixedIncome}%,
        #f0f7f9 0%,
        #d8ebf1 25%,
        #9cb9ca 50%,
        #7ea1b2 75%,
        #627f90 100% ${100 - fixedIncome}%
      )`,
    };
  } else if (
    value === "SHORTTAXFREE" ||
    value === "INTERNTAXFREE" ||
    value === "LONGTAXFREE"
  ) {
    backgroundStyle = {
      background: `radial-gradient(
        ellipse at center,
        #2c3b4d 0%,
        #3d4f64 25%,
        #567087 50%,
        #7a9db4 75%,
        #a4c4dc 100%
      )`,
      backgroundImage: `linear-gradient(
        to top, #a8a8a8 ${fixedIncome}%,
        #2c3b4d 0%,
        #3d4f64 25%,
        #567087 50%,
        #7a9db4 75%,
        #a4c4dc 100%
        ${100 - fixedIncome}%
      )`,
    };
  }

  return (
    <div className="container">
      <div
        className="ball"
        id="ball"
        style={{
          width: `${radius}px`,
          height: `${radius}px`,
          borderRadius: "50%",
          ...backgroundStyle,
          boxShadow: "0px 1px 7px rgba(0, 0, 0, 0.7)",
          transform: "translateZ(20px)",
        }}
        data-toggle="tooltip"
        data-placement="top"
        title={`Asset Name: ${onHoverData.assetName}\n% of Total Investments: ${
          onHoverData.percentageInvested
        }${
          fixedIncome > 0
            ? "\n% as Fixed Income: " + onHoverData.fixedIncome
            : ""
        }`}
      />
    </div>
  );
}
